import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Duration } from './duration';
export var SpeakingTime = /*#__PURE__*/function (_Duration) {
  _inherits(SpeakingTime, _Duration);

  var _super = _createSuper(SpeakingTime);

  function SpeakingTime() {
    _classCallCheck(this, SpeakingTime);

    return _super.apply(this, arguments);
  }

  _createClass(SpeakingTime, null, [{
    key: "create",
    value: function create() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SpeakingTime.defaultValue;
      var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SpeakingTime.defaultUnit;
      return this.createDuration(value, unit, this.minTime, "Speaking time cannot be less than ".concat(this.minTime), function (props) {
        return new SpeakingTime(props);
      });
    }
  }]);

  return SpeakingTime;
}(Duration);

_defineProperty(SpeakingTime, "defaultValue", 60);

_defineProperty(SpeakingTime, "defaultUnit", 'second');

_defineProperty(SpeakingTime, "minTime", 0);

_defineProperty(SpeakingTime, "default", SpeakingTime.create(SpeakingTime.defaultValue, SpeakingTime.defaultUnit).getValue());